import '../style/style.scss';

import { sayHello, newActivityTitle, handleErrorResponse } from './utils';
import { environment } from './environment';
// import {MDCTopAppBar} from '@material/top-app-bar';

// const topAppBarElement = document.querySelector('.mdc-top-app-bar');
// const topAppBar = new MDCTopAppBar(topAppBarElement);

const app = new Vue({
  el: '#app',
  data: {
    activity: {
      title: newActivityTitle(),
      description: null
    },
    timer: {
      start: null,
      end: null
    },
    timerInterval: null,
    error: null,
    recentActivities: []
  },
  mounted() {
    this.getRecentActivities()
  },
  computed: {
    newActivityTitle() {
      return 'Activity ' + new Date().getTime();
    },
    timeDiff() {
      let diff;
      if (this.timer.start && this.timer.end) {
        return parseInt((this.timer.end - this.timer.start) / 1000);
      }
      return diff;
    }
  },
  filters: {
    timeElappsed(time /*in seconds*/) {
      if (!time || time === 0) {
        return '0:0:0';
      }
      const hour = parseInt(time / (60 * 60)); /* seconds in hour */
      let mins = parseInt(time / 60); /* seconds in a min */
      // mins = mins < 60 ? mins : 0;
      let seconds = parseInt(time);
      // seconds = seconds > 0 && seconds < 60 ? seconds : 60;
      return `${hour}:${mins}:${seconds}`;
    },
    readableDate(date) {
      return new Date(date).toLocaleString();
    }
  },
  methods: {
    startClick() {
      const now = new Date();
      this.timer.start = now;
      this.timer.end = now;
      this.error = null
      this.timerInterval = setInterval(() => {
        this.timer.end = new Date();
      }, 1000);
    },
    cancelClick() {
      this.saveActivity()
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      this.timerInterval = null;
      this.timer.start = null;
      this.timer.end = null;
    },
    removeError() {
      this.error = null;
    },
    saveActivity() {
      axios
        .post(environment.base+'/activity', {
          title: this.activity.title,
          description: this.activity.description,
          duration: this.timeDiff
        })
        .then(d => {
          console.log(d.data);
          this.activity.description = null;
          this.activity.title = newActivityTitle()
          this.addLatestActivityToRecents(d.data);
        })
        .catch(errRes => this.error = handleErrorResponse(errRes));
    },
    addLatestActivityToRecents(activity) {
      const rest = this.recentActivities.slice(0, this.recentActivities.length - 1);
      this.recentActivities = [activity, ...rest]
    },
    getRecentActivities() {
      axios
        .get(environment.base+'/recent', {
          params: {
            limit: 5,
            sort: -1
          }
        })
        .then(d => {
          this.recentActivities = d.data;
        })
        .catch(errRes => this.error = handleErrorResponse(errRes));
    }
  }
});

